import { AgendaLandingSeoHead } from "@/components/agenda-landing/AgendaLandingSeoHead";
import { AgendaLandingView } from "@/components/agenda-landing/AgendaLandingView";

export default function AgendaOnlineParaBarbeariaPage() {
  return (
    <>
      <AgendaLandingSeoHead />
      <AgendaLandingView />
    </>
  );
}
